import React, { useState, useContext, useEffect } from 'react';
import { addcontext } from '../../ContextShare/ContextShare';
import DatePicker from 'react-datepicker';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import { AddEvtnt, GetEvent } from '../../Services/allApi';

function AddNewEvent() {
    const { addEvent, setaddEvent } = useContext(addcontext)

    const [eventData, setEventData] = useState({
        event_name: '',
        mal_event_name:''
    });
 
    const [existingEvents, setExistingEvents] = useState([
        // { id: 1, name: 'Event 1' },
        // { id: 2, name: 'Event 2' },
        // { id: 3, name: 'Event 3' },
        
    ]);

    const [isConsAdded,setisConsAdded]=useState(true)

    const handleSave = async () => {
        const token=sessionStorage.getItem('access_token')
        const reqHeader = {
         "Content-Type": "application/json",
         "Authorization": `${token}`
     };
    
        const res=await AddEvtnt(eventData,reqHeader)
        console.log(res);
       if(res?.status==200){
        toast.success("Event added successfully")
        setEventData({event_name: '',mal_event_name:''})
        setisConsAdded(!isConsAdded)
        setTimeout(()=>{
            setaddEvent(!addEvent)
        },1000)
       }
       else{
         const messageData = res?.response?.data?.message;
         // Check if messageData is an object
         const errorMessage = typeof messageData === 'object' && messageData !== null
             ? messageData[Object.keys(messageData)?.[0]]?.[0] // Get the first message from the object
             : messageData; // If it's a string, use it directly
         toast.error(errorMessage ?? "There was a problem adding event");
     }
       
    };

    const GetExistingEvent=async()=>{
        const result=await GetEvent()
        console.log(result);
        const newEventList=result.data?.data?.map((item)=>(
             { id: item.event_id, name:item.event_name  }
        ))
        setExistingEvents(newEventList)
    }
    useEffect(()=>{
        GetExistingEvent()
    },[isConsAdded])

    // const eventAddScript=async(data)=>{
    //     const token=sessionStorage.getItem('access_token')
    //     const reqHeader = {
    //      "Content-Type": "application/json",
    //      "Authorization": `${token}`
    //  };
    //     const res=await AddEvtnt({event_name:data,mal_event_name:data},reqHeader)
    // }
    
    // const activateScript=()=>{
    // for (var i=0;i<=25;i++){
    //     const newEvent='event'+i
    //     eventAddScript(newEvent)
    // }
    // }
    return (
        <>
            <div className='w-full flex items-center flex-col'>
                {/* <button onClick={activateScript}>ActivateScript</button> */}
                <h3 className='text-blue-700 text-xl font-bold mt-5 mb-5 text-center'>Enter Event Details</h3>

                <div className='flex flex-row justify-center flex-wrap mb-5 ms-5 me-5 gap-5 w-full '>
                    <div className='w-3/12 flex flex-col'>
                        <label htmlFor="eventname">Name of the event</label>
                        <input
                            id='eventname'
                            placeholder='Add new event'
                            value={eventData.event_name}
                            onChange={(e) => setEventData({ ...eventData, event_name: e.target.value })}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>

                    <div className='w-3/12 flex flex-col'>
                        <label htmlFor="eventname">Name of the event in Malayalam </label>
                        <input
                            id='eventname'
                            placeholder='Enter in malayalam'
                            value={eventData.mal_event_name}
                            onChange={(e) => setEventData({ ...eventData, mal_event_name: e.target.value })}
                            type="text"
                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                        />
                    </div>
                </div>

                <br />
                <div className='w-2/12'>
                    <button className='w-full py-2 bg-primary text-white rounded-full' onClick={handleSave}>Save</button>
                </div>

                <div className='w-11/12 mt-10 border bg-success '>
                    <h4 className='text-blue-700 text-lg font-bold mb-5 mt-5 text-center'>Existing Events</h4>
                    <div className='flex flex-col items-center mb-5'>
                        {existingEvents?.map(event => (
                            <div key={event.id} className='bg-white shadow-md rounded-lg px-4 py-2 mb-2 w-6/12 border border-gray-200'>
                                <div className='text-lg font-semibold'>{event.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            /> */}
        </>
    );
}

export default AddNewEvent;
